import { createFileRoute, redirect } from '@tanstack/react-router';
import { SessionErrorPage } from '@/components/shell/SessionErrorPage';
import { sessionQuery } from '@/lib/use-session';

// Landing route. Authed users → /feed, unauthed → /auth/signup (growth
// default: a first-time visitor typing the bare domain is more likely a
// prospective member than a returning one; returning users get the Sign
// in button at the bottom of the signup card, and deep links into the
// product still bounce to /auth/login via `_authed`).
//
// Error classification: the session probe resolving NULL is the
// definitive signed-out verdict → /auth/login. The probe THROWING
// (network failure, server 5xx — react-query has already exhausted its
// retries) means the auth state is UNKNOWN → the error propagates to
// `errorComponent`, which renders a retryable surface. Routing fetch
// errors to /auth/login treated "couldn't determine" as "signed out"
// and logged returning users out during deploys/outages.
export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const data = await context.queryClient.ensureQueryData(sessionQuery);
    throw redirect({ to: data !== null ? '/feed' : '/auth/signup' });
  },
  errorComponent: SessionErrorPage,
});
